if (!customElements.get('bt-notify-me-modal')) {
  class BtNotifyMeModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.handleClick = this.handleClick.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleKitAdded = this.handleKitAdded.bind(this);
      this.dialog.addEventListener('click', this.handleClick);
      this.dialog.addEventListener('submit', this.handleSubmit);
      document.addEventListener('product-ajax:added', this.handleKitAdded);

      const events = window.MinimogTheme?.pubSubEvents;
      if (window.MinimogEvents && events?.variantChange) {
        this.unsubscribe = MinimogEvents.subscribe(events.variantChange, this.handleVariantChange.bind(this));
      }

      const form = this.dialog.querySelector('form');
      if (form && window.location.hash === `#${form.id}`) this.open();
    }

    disconnectedCallback() {
      this.dialog?.removeEventListener('click', this.handleClick);
      this.dialog?.removeEventListener('submit', this.handleSubmit);
      document.removeEventListener('product-ajax:added', this.handleKitAdded);
      this.unsubscribe?.();
    }

    handleKitAdded({ detail } = {}) {
      if (!this.dialog.contains(detail?.submitButton)) return;
      this.dialog.close();

      const drawer = document.querySelector('m-cart-drawer');
      if (window.MinimogSettings?.enable_cart_drawer && drawer?.open) {
        // layout/theme.liquid só deixa o drawer abrir quando recebe o elemento que o acionou.
        drawer.open(document.querySelector('.m-cart-icon-bubble') || detail.submitButton);
      } else {
        window.location = window.MinimogSettings?.routes?.cart || '/cart';
      }
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    handleClick(event) {
      if (event.target === this.dialog || event.target.closest('[data-bt-notify-close]')) {
        this.dialog.close();
      }
    }

    handleVariantChange({ data } = {}) {
      if (!data?.html || String(data.sectionId) !== this.dataset.sectionId) return;

      this.querySelectorAll('[data-bt-notify-sync]').forEach((node) => {
        const next = data.html.getElementById(node.id);
        if (!next) return;
        if (node instanceof HTMLInputElement) {
          node.value = next.value;
        } else {
          node.innerHTML = next.innerHTML;
        }
      });
    }

    async handleSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.bt-notify-form')) return;
      event.preventDefault();

      const submit = form.querySelector('[type="submit"]');
      submit?.setAttribute('aria-busy', 'true');
      if (submit) submit.disabled = true;

      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.getElementById(form.id);
        const hasResult = next?.querySelector('[data-bt-notify-posted], .notification');
        if (!response.ok || !hasResult) throw new Error('bt-notify: native submit');

        const tags = form.elements['contact[tags]']?.value;
        form.innerHTML = next.innerHTML;
        const tagsInput = form.elements['contact[tags]'];
        if (tagsInput && tags) tagsInput.value = tags;
        form.querySelector('[data-bt-notify-posted] [tabindex="-1"]')?.focus();
      } catch (error) {
        form.submit();
      } finally {
        submit?.removeAttribute('aria-busy');
        if (submit) submit.disabled = false;
      }
    }
  }

  customElements.define('bt-notify-me-modal', BtNotifyMeModal);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('button[data-notify-me][aria-controls]');
    if (!trigger) return;
    document.getElementById(trigger.getAttribute('aria-controls'))?.closest('bt-notify-me-modal')?.open();
  });

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits && `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    const split = digits.length === 11 ? 7 : 6;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, split)}-${digits.slice(split)}`;
  };

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.matches('[data-bt-notify-phone]')) {
      input.value = formatPhone(input.value);
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.bt-notify-form')) return;
      const tags = form.elements['contact[tags]'];
      const phone = form.querySelector('[data-bt-notify-phone]')?.value.trim();
      if (!tags) return;

      const list = tags.value
        .split(',')
        .map((tag) => tag.trim())
        .filter((tag) => tag && !tag.startsWith('tel:'));
      if (phone) list.push(`tel: ${phone}`);
      tags.value = list.join(', ');
    },
    true
  );
}
